import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { MyDirectiveModule } from '@core/directives/my-directive.module';
import { StyleClassModule } from 'primeng/styleclass';
import { InternationalizationService } from './core/i18n';

@Component({
  selector: 'app-root',
  imports: [CoreModule, RouterOutlet, MyDirectiveModule, StyleClassModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private i18nService = inject(InternationalizationService);
  title = 'Browser-oms';

  constructor() {
    this.i18nService.setLocalization('it');
  }
}
